import React from 'react'
import Typography from '@material-ui/core/Typography'
import { Link } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'
import { makeStyles } from '@material-ui/core/styles'
import ResponsiveModal, { ModalSizes } from '@src/components/ResponsiveModal'
import DataTable from '@src/routes/Configurators/components/DataTable'
import DoneIcon from '@material-ui/icons/Done'
import Box from '@src/components/Box'

const useStyles = makeStyles((theme) => ({
  modalLink: {
    cursor: 'pointer',
    fontSize: theme.typography.pxToRem(16),
  },
  doneIcon: {
    color: theme.palette.primary.main,
    fontSize: 16,
  },
  title: {
    letterSpacing: 1,
  },
  tabelCell: {
    padding: theme.spacing(2, 3),
  },
}))

const CustomCrisprRecommendationModal = () => {
  const classes = useStyles()
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false)
  function createData(label, crRNA, sgRNA, modifiedcrRNA, modifiedsgRNA) {
    return { label, crRNA, sgRNA, modifiedcrRNA, modifiedsgRNA }
  }

  const rows = [
    createData('Easy-to-transfect cells', true, true, true, true),
    createData('Hard-to-transfect cells', false, false, true, true),
    createData('Primary cells', false, false, true, true),
    createData('Animal embroys', true, true, true, true),
  ]
  const tableColumns = [
    {
      headElement: (
        <>
          <FormattedMessage {...messages.CONF_POPUP_APPLICATION} />
        </>
      ),
      bodyElement: (row) => row?.label,
    },
    {
      headElement: (
        <FormattedMessage
          {...messages.CUSTOM_CRISPR_CRRNA_POPUP_customcrispr}
        />
      ),
      bodyElement: (row) =>
        row.crRNA ? <DoneIcon className={classes.doneIcon} /> : <></>,
      textAlign: 'center' as const,
    },
    {
      headElement: (
        <FormattedMessage
          {...messages.CUSTOM_CRISPR_SGRNA_POPUP_customcrispr}
        />
      ),
      bodyElement: (row) =>
        row.sgRNA ? <DoneIcon className={classes.doneIcon} /> : <></>,
      textAlign: 'center' as const,
    },
    {
      headElement: (
        <FormattedMessage
          {...messages.CUSTOM_CRISPR_MOD_SGRNA_POPUP_customcrispr}
        />
      ),
      bodyElement: (row) =>
        row.modifiedcrRNA ? <DoneIcon className={classes.doneIcon} /> : <></>,
      textAlign: 'center' as const,
    },
    {
      headElement: (
        <FormattedMessage
          {...messages.CUSTOM_CRISPR_MOD_CRRNA_POPUP_customcrispr}
        />
      ),
      bodyElement: (row) =>
        row.modifiedsgRNA ? <DoneIcon className={classes.doneIcon} /> : <></>,
      textAlign: 'center' as const,
    },
  ]
  return (
    <>
      <Link onClick={() => setIsModalOpen(true)} className={classes.modalLink}>
        <FormattedMessage {...messages.CUSTOM_CRISPR_RECOMMENDATIONS} />
      </Link>
      <ResponsiveModal
        size={ModalSizes.Large}
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        renderTitle={() => (
          <Typography variant="h2" component="h2" className={classes.title}>
            <FormattedMessage {...messages.CUSTOM_CRISPR_RECOMMENDATIONS} />
          </Typography>
        )}
      >
        <Box mt={6} mr={8} mb={8} ml={8}>
          <DataTable
            data={rows}
            columns={tableColumns}
            tableCellClass={classes.tabelCell}
          />
        </Box>
      </ResponsiveModal>
    </>
  )
}
export default CustomCrisprRecommendationModal
